import React from 'react';
import { Col, Input, Label, Row } from 'reactstrap';
import { DeleteLessonFormProp } from '../../../../../types/Forms';
import { useTranslation } from 'react-i18next';
const PreMigrationStepForm: React.FC<DeleteLessonFormProp> = ({
  lessionTitle,
  formData,
  updateFormData,
  register,
  errors,
}) => {
  const { t } = useTranslation();
  return (
    <Row className="g-3">
      <h2 className="mb-3">
        {t('courses.lessons.confirmDeleteLesson', { lessonTitle: lessionTitle })}
      </h2>
      <Col xs="12">
        <div className="checkbox checkbox-primary mb-0 form-check">
          <Input
            {...register('deleteVideo')}
            checked={formData.deleteVideo}
            type="checkbox"
            onChange={updateFormData}
            className="form-check-input"
            id="delVideoCheck"
          />
          <Label htmlFor="delVideoCheck" className="form-check-label">
           <h4> {t('courses.lessons.deleteAlsoVideo')}</h4>
          </Label>
        </div>
      </Col>
    </Row>
  );
};
export default PreMigrationStepForm;
